const initialState = () => ({
  isMyAccountViewActive: false,
  isSecurityPermitsViewActive: false,
  enable_bases: false,
});

const state = initialState();

export default state;
